<template>
<div>

<!-- Large modal -->


<div class="modal checkProduct-modal-lg" id="checkProduct-modal-lg" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true" data-backdrop="static">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header border-primary">
        <spinner v-bind:spinner='spinner'></spinner>
 
        <h4 class="modal-title" style="color:navy" id="exampleModalLabel"> 
          <i class="fas fa-bullhorn mr-2" aria-hidden="true"></i> 
          <strong>ARTICOLO CON CODICE <strong> <span style="color:red"> {{sku}}</span>   </strong>  GIA' ESISTENTE.</strong>  </h4>
        
        

        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        
      </div>

      <div class="modal-body">
        <h5><small>Doppio click seleziona prodotto.</small></h5>  
      <alert-box @close="msg.title=''" v-bind:msg="msg"  ></alert-box>

      <div class="table-wrapper-scroll-y my-custom-scrollbar mt-2">

      <table class="table table-hover table-striped mb-0">
      <thead class="table-primary" >
          <tr>
          <th scope="col">ID</th>
          <th scope="col">CODICE</th>
          <th scope="col">BRAND</th>
          <th scope="col">CATEGORIA</th>
          <th scope="col">DESCRIZIONE</th>
          <th scope="col">REPARTO</th>
          <th scope="col">STAGIONE</th>
          <th scope="col">DATA REG.</th>
          <th scope="col">N.RO VARIANTI</th>
        
          </tr>
      </thead>
      <tbody>
      <tr data-toggle="tooltip" title="Doppio click seleziona Prodotto" class="pointer" v-on:dblclick="setProduct(item)" v-for="(item, index) in items[0]" :key="index">
      <td>{{item.productId}}</td>
      <td>{{item.sku}}</td>
      <td>{{item.brand}}</td>
      <td>{{item.category}}</td>
      <td>{{item.description}}</td>
      <td>{{item.department}}</td>
      <td>{{item.season}}-{{item.season_year}} </td>
      <td>{{item.create_at}} </td>
      <td>{{item.counter}} </td>
     
    </tr> 
  </tbody>
  </table>
  </div>

</div>





<div class="modal-footer">
        <button type="button" class="btn btn-primary" data-dismiss="modal">
          
          CHIUDI</button>
        <div v-if="!btn">
        <button @click="createProduct()"  :disabled="btn" type="button" class="btn btn-success" data-dismiss="modal">
          <i class="fas fa-check-circle mr-2" aria-hidden="true"></i>   
          REGISTRA NUOVO PRODOTTO E PROCEDI</button>
        </div>
      </div>
    </div>
  </div>
</div>
  
 


</div>


</template>
<script>
import alertBox          from '@/components/common/AlertBox.vue';
import spinner           from '@/components/common/Spinner.vue';



import api               from '@/api'
import { mapGetters }    from 'vuex';


export default {
  
  components  : { alertBox, spinner },
  props : ['items','sku','btn'],
  data() {
    return {
      /*supplier        : '',  */
      /*sku             : '',*/
      /*items           : [],*/
      
      msg             : {
        title : '',
        body  : '',
        type  : 0      
      },
      
      

      spinner         : false    
      
    };
  },
  computed :{

    ...mapGetters(['company']),
    
  },

  
  mounted: function() {},
  created: function() {
  },
  methods: {
    

    createProduct()
    {
      this.$emit('createProduct')
    },
    async setProduct(product)
    {
     
      this.msg.title = ''  
      this.spinner = true          
      var sp = {'sp':'spProductBarcodes'}
      
      var data  = {'productId' : product.productId}
      var json  = Object.assign(data, sp);
      await api.post(json).then(res => {
        if(res.status==200)
          {
            product.barcodes = res.data.recordsets[0]
            this.$emit('update',product)         
          }
          else if(res.status==500)
          {
          
            this.msg.title = 'ATTENZIONE '
            this.msg.body = res.data
            this.msg.type = 1

          } 
          else
          {
          
            this.msg.title = 'ATTENZIONE '
            this.msg.body = res
            this.msg.type = 1
          } 
      }).catch(err => 
      {
        
          this.msg.title = 'ATTENZIONE '
          this.msg.body = err.message
          this.msg.type = 1    
          
      }).finally(() => {
        this.spinner = false
      });

      

    },

    
    
    



  }
};
</script>
<style scoped>

.my-custom-scrollbar {
position   : relative;
height     : 500px;
overflow   : auto;
}
.pointer:hover
{
  background-color  : blue;
  color             : white;
  cursor            : pointer;
}
.table-wrapper-scroll-y {
display: block;
}
.table thead  tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : #66CCFF; 
    color        : black;   
    position     : sticky;
    top          : 0;
    z-index      : 10;
    height       : 40px;

 }


h4 {
  font-family: 'Roboto Condensed';
  font-size: 18px;
}
p {
  font-family  : 'Roboto Condensed';
  font-size    : 28px;
  color        :darkgreen;
}
.modal-content {
  -webkit-border-radius: 0px !important;
  -moz-border-radius: 0px !important;
  border-radius: 15px !important;
  -webkit-border: 0px !important;
  -moz-border: 15px !important;
  border: 0px !important;
}

</style>